module.exports = __webpack_public_path__ + "img/mail-app.af24a235.png";